import users from './users'

const stringToUint8 = (str) => {
    return Uint8Array.from(str, c => c.charCodeAt(0))
}

export default {
    // https://w3c.github.io/webauthn/#sctn-cryptographic-challenges
    createRegistrationOptions (username) {
        return {
            rp: {
                name: 'Cell[0] Inspiratietuin',
                id: window.location.hostname,
            },
            user: {
                id: stringToUint8(username),
                name: username,
                displayName: username,
            },
            challenge: this.createChallenge(),
            pubKeyCredParams: [
                {
                    // see https://www.iana.org/assignments/cose/cose.xhtml#algorithms
                    alg: -7,
                    type: 'public-key',
                },
            ],
            // do we want to be sure a certain kind of device has been used?
            // none is no, A value of 'indirect' means that the server will allow for
            // anonymized attestation data,
            // direct is yes (we would receive attestation data)
            attestation: 'none',
            authenticatorSelection: {
                // Selects between bound or detachable authenticators, "platform" / "cross-platform"
                // authenticatorAttachment,
                // Select authenticators that support username-less flows
                // requireResidentKey: true,
                // Select authenticators that have a second factor (e.g. PIN, Bio)
                // userVerification: 'required',
            },
        }
    },

    register (username, credential) {
        // this is where credentials MUST be checked in a real implementation
        // see: https://w3c.github.io/webauthn/#sctn-registering-a-new-credential

        users.upsert({
            username: username,
            credential,
        })

        return true
    },

    createLoginOptions (username) {
        const user = users.get(username)

        const options = {
            challenge: this.createChallenge(),
            allowCredentials: [
                {
                    id: user.credential.rawId,
                    type: 'public-key',
                    // transports: ['internal', 'usb', 'ble', 'nfc'],
                },
            ],
        }

        return options
    },

    login (username, assertion) {
        // this is where login assertion MUST be checked in a real implementation

        const user = users.get(username)
        user.loginSuccess = true

        return true
    },

    createChallenge () {
        return Uint8Array.from({ length: 32 }, () => Math.floor(Math.random() * 255))
    },
}
